export default {
	formatAddress: ({ address, city, province }: { address: string; city: string; province: string }): string => {
		return address + ', ' + city + ', ' + province;
	},
};
